import { keepPreviousData, useQuery } from '@tanstack/react-query';
import dayjs from 'dayjs';
import { useParams } from 'react-router';

import { apiClient } from '../api-client.ts';
import type { TransferDto } from '../types';

export type TransfersFilters = {
  party?: string;
  type?: string;
  categoryId?: string;
  dateFrom?: Date;
  dateTo?: Date;
};

export const useTransfers = (filters: TransfersFilters) => {
  const { projectId } = useParams();

  return useQuery<TransferDto[]>({
    queryKey: ['transfers', projectId, filters],
    queryFn: () =>
      apiClient.get(`/v1/projects/${projectId}/transfers`, {
        params: {
          ...filters,
          dateFrom: filters.dateFrom
            ? dayjs(filters.dateFrom).startOf('day').toISOString()
            : undefined,
          dateTo: filters.dateTo ? dayjs(filters.dateTo).startOf('day').toISOString() : undefined,
        },
      }),
    placeholderData: keepPreviousData,
    enabled: !!projectId,
  });
};
